<template>
    <div>
        <div class="container search">
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-6">
                            <h2>
                                Add New Price Rule
                            </h2>
                        </div>
                        <div class="col-md-6 text-right">
<a href="/price-rules">Back To list</a>
                        </div>
                    </div>
                    <form @submit.stop.prevent="onSubmit">
                        <messages :messages="messages"/>
                    <div class="row">
                        <div class="col-md-12 container-search">
                            <div class="form-row">
                                <b-form-group class="col-md-6"
                                              label="Name"
                                              :label-for="getId('name')"
                                              :state="fieldState('name')"
                                              :invalid-feedback="invalidField('name')"
                                >
                                    <b-form-input
                                            ref="name_input"
                                            :id="getId('name')"
                                            type="text"
                                            v-model="price.name"
                                            :state="fieldState('name')"
                                            placeholder="Enter name">
                                    </b-form-input>
                                </b-form-group>
                                <b-form-group class="col-md-6"
                                              label="Formula"
                                              :label-for="getId('formula')"
                                              :state="fieldState('formula')"
                                              :invalid-feedback="invalidField('formula')"
                                >
                                    <b-form-input
                                            ref="name_input"
                                            :id="getId('formula')"
                                            type="text"
                                            v-model="price.formula"
                                            :state="fieldState('formula')"
                                            placeholder="Enter formula">
                                    </b-form-input>
                                </b-form-group>
                            </div>

                            <div class="form-row">
                                <b-form-group class="col-md-6"
                                              label="Currency"
                                              :label-for="getId('currency')"
                                              :state="fieldState('currency')"
                                              :invalid-feedback="invalidField('currency')"
                                >
                                    <b-form-select
                                            ref="name_input"
                                            :id="getId('currency')"
                                            v-model="price.currency"
                                    >
                                        <option :value="index" v-for="(item, index) in currencies">{{ item }}</option>
                                    </b-form-select>
                                </b-form-group>
                                <b-form-group class="col-md-6"
                                              label="Rounding"
                                              :label-for="getId('rounding')"
                                              :state="fieldState('rounding')"
                                              :invalid-feedback="invalidField('rounding')"
                                >
                                    <b-form-select
                                            ref="name_input"
                                            :id="getId('rounding')"
                                            v-model="price.rounding"
                                    >
                                        <option :value="index" v-for="(item, index) in roundingData">{{ item }}</option>
                                    </b-form-select>
                                </b-form-group>
                            </div>
                            <div class="form-row">
                                <b-form-group class="col-md-12"
                                              label="Note"
                                              :label-for="getId('note')"
                                              :state="fieldState('note')"
                                              :invalid-feedback="invalidField('note')"
                                >
                                    <b-form-textarea
                                            ref="name_input"
                                            :id="getId('note')"
                                            v-model="price.note"
                                    >
                                    </b-form-textarea>
                                </b-form-group>

                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-6">
                                    <b-btn type="submit" class="btn">Save</b-btn>
                                </div>
                            </div>
                        </div>
                    </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState, mapActions } from 'vuex'
    import {objLookup} from '../../util/common'
    import BootstrapValidation from '../../mixins/bootstrap-validation';
    export default {
        props: [
            'price_rule',
            'titile'
        ],
        mixins: [BootstrapValidation],
        data() {
            return {
                price: {
                    name: null,
                    formula: null,
                    note: null,
                    currency: null,
                    rounding: null,
                },
                messages: [],
                currencies: {'YEN': 'YEN', 'NZD': 'NZD'},
                roundingData: {'1': '1', '10': '10', '100': '100'},
                priceRule : this.price_rule,
            }
        },
        computed: {
            ...mapState({

            }),
        },
        mounted() {
            this.fillFormDetails();
        },
        methods: {
            objLookup(obj, key){
                return objLookup(obj, key);
            },
            getId(name){
                return name;
            },
            fillFormDetails () {
             this.price = this.priceRule
            },
            onSubmit(){
                this.messages = [];
                if (this.priceRule) {
                    this.$store.dispatch('priceRule/updatePriceRule',{
                        data: this.price,
                        id: this.priceRule.id
                    }).then(response => {
                        if(response && response.message) {
                            this.messages.push({type: 'success', message: 'Price Rule updated.'});
                            this.user = response.data;
                        } else {
                            this.messages.push({type: 'danger', message: 'Unable to update.'});
                        }
                    }).catch(error => {
                        this.messages.push({type: 'danger', message: error.message});
                        this.errors = error.errors;

                    });
                } else {
                    this.$store.dispatch('priceRule/storePriceRule', {
                        data: this.price,
                    }).then(response =>{
                        if(response && response.message){
                            this.messages.push({type: 'success', message: 'New Price Rule created successfully.'});
                            this.price = [];
                            this.errors = [];
                        } else {
                            this.messages.push({type: 'danger', message: 'Unable to create.'});
                        }
                    }).catch(error => {
                        this.messages.push({type: 'danger', message: error.message});
                        this.errors = error.errors;

                    });
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/PriceRule/CreatePage.vue